import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { CameraService } from '../services/camera.service';
import { ToastrWrapperService } from '../services/toastr-wrapper.service';

@Component({
  selector: 'app-camera',
  templateUrl: './camera.component.html',
  styleUrls: ['./camera.component.css']
})
export class CameraComponent implements OnInit {
  @Output() imageTaken: EventEmitter<WebcamImage[]> = new EventEmitter<WebcamImage[]>();
  public picturesTaken: WebcamImage[] = [];

  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  isMobile = true;
  cameraDetected = true;
  public videoOptions: MediaTrackConstraints = {
    // width: {ideal: 1024},
    // height: {ideal: 576}
  };
  public errors: string[] = [];

  // webcam snapshot trigger
  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  isIOS: boolean = false;

  constructor(private cameraService: CameraService,
    private toasterService: ToastrWrapperService) { }

  public ngOnInit(): void {
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
    // console.log('userAgent', navigator.userAgent);
    this.isMobile = /Mobi|Android/i.test(navigator.userAgent);
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    console.log(error.mediaStreamError.name, error);
    this.cameraDetected = false;

    if (this.isMobile) {
      this.toasterService.showWarning("Please enable camera access for NHConnect to take photos (" + error.mediaStreamError.name + ")");
    } else {
      this.toasterService.showWarning("Please enable camera access to take photos (" + error.mediaStreamError.name + ")");
    }

  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    // true => move forward through devices
    // false => move backwards through devices
    // string => move to device with given deviceId
    this.nextWebcam.next(directionOrDeviceId);
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info('received webcam image', webcamImage);
    this.picturesTaken[0] = webcamImage;
    this.imageTaken.next(this.picturesTaken);
    //this.savePictureToCloud()
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }
}
